;(function($){
var forceScroll = false;

$.fn.isInViewport = function() {
    var elementTop = $(this).offset().top;
    var elementBottom = elementTop + $(this).outerHeight();
    var viewportTop = $(window).scrollTop();
    var viewportBottom = viewportTop + $(window).height();
    return elementBottom > viewportTop && elementTop < viewportBottom;
};

$.fn.setCalendarWidth = function(){
    var draggableWidth = $('#decades-draggable').width();
    var currentDifference = $(this).width() / 2 - draggableWidth;
    $(this).width(function(i,currentWidth){
        return currentWidth + (currentDifference * (-2));
    })
    $(this).css('transform',`translateX(${currentDifference}px)`);
}

$.fn.drawLine = function(){
    var st = $(window).scrollTop();

    if(st > 0 && $(this).not(':visible')){
        $(this).css({height: st}).show()
    }else{
        $(this).hide();
    }
};

$.fn.showTimelineBar = function(offsetTop){
    var scrollTop = $(window).scrollTop();

    if (offsetTop < scrollTop && !$(this).hasClass('sticky')) {
        $(this).addClass('sticky');
    } else if (offsetTop > scrollTop && $(this).hasClass('sticky')) {
        $(this).removeClass('sticky');
    }
}

var scrollToDecade = function(decade, withDrag, withScroll){

    $('#decades-draggable a.active').removeClass('active');
    $("[data-year='"+decade+"']").addClass('active');
    if(withScroll) {
        $('html, body').animate({
            scrollTop: $("[data-decade='" + decade + "']").offset().top - 135
        }, function(){
            setTimeout(function(){
                forceScroll = false;
            }, 100);
        });
        forceScroll = true;
    }

    if(withDrag){
        var elIndex = $("[data-year='"+decade+"']").parents('ul').find('li').index($("[data-year='"+decade+"']").parent());
        var posLeft = elIndex * 52;
        $('#decades-draggable').stop().animate({'left' : - posLeft});
    }

    window.location.hash = '#' + decade;
};


$(document).ready(function(){

     AOS.init({
        disable: 'phone'
    });  

    if($('body').hasClass('page-template-tmp-timeline')||$('body').hasClass('page-template-tmp-timeline-150')) {
        $('#timeline_line').drawLine();
        $('#calendar').setCalendarWidth();
         var decadesList = $( "#decades-draggable" ).draggable({
            axis: "x",
            containment: "#calendar",
            grid: [ 52, 20 ],
            refreshPositions: true,
            create: function( event, ui ) {
                $('.years_container>ul>li:first a').addClass('active');
            },
            start: function( event, ui ) {
                $('.years_container li a.active').removeClass('active');
            },
            stop: function( event, ui ) {
                var step = parseInt(Math.abs(ui.position.left)/52);
                var decade = $('.years_container>ul>li:eq('+step+') a').data('year');
                scrollToDecade(decade, false, true);
            } 
        }); 

         $("#timeline #calendar .years ul li a").on('click', function(event) {
            event.preventDefault();

            if (this.hash !== "") {
                var decade = $(event.target).data('year');

                scrollToDecade(decade, true, true);
            }
        });
       var currentDecade = null;
        $('.decade').each(function (k, e) {
            if ($(e).isInViewport()) {
                currentDecade = $(e).data('decade');
            }
        }); 


        //console.log(currentDecade);
        var scrollTop = $(window).scrollTop();
        var timelineBarTop = $('#calendar').offset().top;
        
        $(window).scroll(function () {
            if(!forceScroll) {
                $('#timeline_line').drawLine();
                var move = false
                $('.decade').each(function (k, e) {
                    if (scrollTop < $(window).scrollTop()) {
                        //console.log('scrolling down');
                        if ($(e).isInViewport() && $(e).data('decade') > currentDecade && !move) {
                            scrollToDecade($(e).data('decade'), true, false);
                            currentDecade = $(e).data('decade');
                            move = true
                        }
                    } else {
                        //console.log('scrolling up');
                        if ($(e).isInViewport() && $(e).data('decade') < currentDecade && !move) {
                            scrollToDecade($(e).data('decade'), true, false);
                            currentDecade = $(e).data('decade');
                            move = true
                        }
                    }
                });

                scrollTop = $(window).scrollTop();
            }

            $('#calendar').showTimelineBar(timelineBarTop);
        });


        if(window.location.hash){
            var decade = window.location.hash.replace('#', "");
            scrollToDecade(decade, true, true);
        }

        $('#calendar').showTimelineBar(timelineBarTop); 
    }

});

}(jQuery));